import { fontStyles, fontWeights } from "../../tokens/typography";
import { body1Styles, body2Styles, body3Styles, header1Styles, header2Styles, header3Styles, header4Styles, header5Styles, smallBody1Styles, smallBody2Styles, smallHeader1Styles, smallHeader2Styles, smallHeader3Styles, smallHeader4Styles, smallHeader5Styles, } from "../../presets/typography";
import { colors } from "../../tokens/color";
import { breakpoints } from "../../tokens/size";
const defaultTypographyStyles = {
    overflowWrap: 'break-word',
    margin: 0,
    fontStyle: fontStyles.normal,
};
const defaultHeadingStyles = {
    ...defaultTypographyStyles,
    color: colors.text.primary,
    fontWeight: fontWeights.bold,
};
const defaultBodyStyles = {
    ...defaultTypographyStyles,
    color: colors.text.secondary,
    fontWeight: fontWeights.regular,
};
export const typographyStyles = {
    header1: {
        ...defaultHeadingStyles,
        ...header1Styles,
        [`@media (max-width: ${breakpoints.sm})`]: {
            ...smallHeader1Styles,
        },
    },
    header2: {
        ...defaultHeadingStyles,
        ...header2Styles,
        [`@media (max-width: ${breakpoints.sm})`]: {
            ...smallHeader2Styles,
        },
    },
    header3: {
        ...defaultHeadingStyles,
        ...header3Styles,
        [`@media (max-width: ${breakpoints.sm})`]: {
            ...smallHeader3Styles,
        },
    },
    header4: {
        ...defaultHeadingStyles,
        ...header4Styles,
        [`@media (max-width: ${breakpoints.sm})`]: {
            ...smallHeader4Styles,
        },
    },
    header5: {
        ...defaultHeadingStyles,
        ...header5Styles,
        [`@media (max-width: ${breakpoints.sm})`]: {
            ...smallHeader5Styles,
        },
    },
    body1: {
        ...defaultBodyStyles,
        ...body1Styles,
        [`@media (max-width: ${breakpoints.sm})`]: {
            ...smallBody1Styles,
        },
    },
    body2: {
        ...defaultBodyStyles,
        ...body2Styles,
        [`@media (max-width: ${breakpoints.sm})`]: {
            ...smallBody2Styles,
        },
    },
    body3: {
        ...defaultBodyStyles,
        ...body3Styles,
    },
};
export const variantStyleMapping = {
    h1: typographyStyles.header1,
    h2: typographyStyles.header2,
    h3: typographyStyles.header3,
    h4: typographyStyles.header4,
    h5: typographyStyles.header5,
    body1: typographyStyles.body1,
    body2: typographyStyles.body2,
    body3: typographyStyles.body3,
};
